import _ from 'lodash';
import { flux } from '@/core/flux.module';
import { getStorageSafely } from '@/utilities/storage.utilities';
import { warnToast } from '@/utilities/toast.utilities';
import type { AnyProperty } from '@/utilities.types';

export let reduxDevtoolsConnection: ReturnType<ReduxDevtoolsExtension['connect']> | undefined;

export let isDebugStoresEnabled: boolean | undefined;

let unsupportedActionToast: number | string | null = null;

function createUnsupportedActionToast() {
  if (!unsupportedActionToast) {
    unsupportedActionToast = warnToast(
      { messageKey: 'Action not fully supported' },
      { onClose: () => (unsupportedActionToast = null) },
    );
  }
}

export const stateSanitizer = (stores: AnyProperty) =>
  _.reduce(stores, (allStoresState, store, storeName) => ({ ...allStoresState, [storeName]: store.state }), {});

export const initializeReduxDevtools = () => {
  const debugStoresSearchParam = _.lowerCase(new URLSearchParams(window.location.search).get('debug-stores') ?? '');

  if (debugStoresSearchParam && debugStoresSearchParam !== 'true') {
    return getStorageSafely().removeItem('debug-stores');
  }

  const debugStoresLocalStorage = Boolean(getStorageSafely().getItem('debug-stores'));

  if (debugStoresSearchParam === 'true' || debugStoresLocalStorage) {
    reduxDevtoolsConnection = window.__REDUX_DEVTOOLS_EXTENSION__?.connect({
      name: 'All stores',
      stateSanitizer,
    });
    reduxDevtoolsConnection?.init({});

    reduxDevtoolsConnection?.subscribe((data) => {
      if (data?.type !== 'DISPATCH' || data.payload?.type === 'PAUSE_RECORDING') {
        return;
      }

      switch (data.payload?.type) {
        case 'COMMIT':
          reduxDevtoolsConnection?.init(stateSanitizer(flux.dispatcher.storeInstances));
          break;
        case 'RESET':
          reduxDevtoolsConnection?.init({});
          createUnsupportedActionToast();
          break;
        default:
          createUnsupportedActionToast();
          break;
      }
    });

    isDebugStoresEnabled = true;
    if (!debugStoresLocalStorage) {
      getStorageSafely().setItem('debug-stores', 'true');
    }
  }
};
